import { DescribeProperty } from '../../common';

export class CreateGrantResponse {
  @DescribeProperty({ description: 'Info message', type: 'string' })
  message: string;
}
